import { Component, OnInit, inject } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import {
  User,
  UserProfileRequestDTO,
} from '../../shared/core/state/users/models';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';

import * as UserActions from '../../shared/core/state/users/user.actions';
import { Router } from '@angular/router';

@Component({
  selector: 'black-add-user-profile',
  templateUrl: './add-user-profile.component.html',
  styleUrl: './add-user-profile.component.css',
  standalone: false,
  host: {
    ngSkipHydration: 'true',
  },
})
export class AddUserProfileComponent implements OnInit {
  private fb = inject(NonNullableFormBuilder);
  private store = inject<Store<State>>(Store);
  private router = inject(Router);


  profileUpdateForm = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    bio: [''],
    avatar: [''],
  });

  user: Partial<User> | null = null;

  error = null;

  ngOnInit(): void {
    this.store
      .select((state) => state.users.user)
      .subscribe((user) => {
        this.user = user;
        if (user) this.restoreFormData(user);
      });
  }

  restoreFormData(user: Partial<User>) {
    this.profileUpdateForm.setValue({
      firstName: user.profile?.personal.firstName ?? '',
      lastName: user.profile?.personal.lastName ?? '',
      bio: user.profile?.personal.biography ?? '',
      avatar: user.profile?.personal.avatar?._id ?? '',
    });
  }

  avatarUploadSuccessHandler(resourceId: string) {
    this.profileUpdateForm.controls.avatar.setValue(resourceId);
  }

  updateProfile() {
    this.profileUpdateForm.markAllAsDirty();
    this.profileUpdateForm.markAllAsTouched();

    if (this.profileUpdateForm.valid) {
      const userProfileFormData = this.profileUpdateForm.value;

      const userProfileRequestDTO: UserProfileRequestDTO = {
        firstName: userProfileFormData.firstName,
        lastName: userProfileFormData.lastName,
        biography: userProfileFormData.bio,
        avatar: userProfileFormData.avatar,
      };

      this.store.dispatch(
        UserActions.updateUserProfile({
          userProfile: userProfileRequestDTO,
          redirectOnSuccess: true,
        })
      );
    } else {
      console.log('Invalid form!', this.profileUpdateForm.errors);
    }
  }

  skipProfileUpdate() {
    this.router.navigate(['live-classes']);
  }

  get firstName() {
    return this.profileUpdateForm.get('firstName');
  }

  get lastName() {
    return this.profileUpdateForm.get('lastName');
  }
}
